// extracted by mini-css-extract-plugin
export default {"wrap":"MediaWatermark_wrap__xq1pv","media":"MediaWatermark_media__yVzHS","watermark":"MediaWatermark_watermark__y1L9C"};